import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class InterestPointService {

  constructor(public http: Http, public mainService: MainService) { }

  findByUser(idUser :String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"interestPoint/findByUser/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByUserBranch(idUser :String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"interestPoint/findByUserBranch/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findPublic() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"interestPoint/findPublic")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"interestPoint")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(interestPoint:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"interestPoint",interestPoint)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(interestPoint:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"interestPoint/"+interestPoint.idInterestPoint,interestPoint)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:number){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"interestPoint/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/interest-point.service.ts